Vue.component('app-game-queen-menu', {
    mounted: function() {
        game.queenMenuComponent = this;
    },
    data: function() {
        return {
            shouldShowModal: false,
            state: null,
            teamInfo: null,
            currentQueenId: null,
            queenData: {}
        };
    },
    methods: {
        showModal: function(val) {
            this.shouldShowModal = val;
        },
        openQueen: function(queenId) {
            game.mainSocket.emit('getQueenInfo', queenId);
        },
        setCurrentQueen: function(data) {
            if (data && data.id) {
                if (!data.doNotOpen) {
                    this.currentQueenId = data.id;
                }
                this.queenData[data.id] = data;

                this.$forceUpdate();
            } else {
                if (!data.doNotOpen) {
                    this.currentQueenId = null;
                }
            }

            if (!data.doNotOpen) {
                game.queenMenuComponent.showModal(!!this.currentQueenId);
            }
        },
        queueBrood: function(type) {
            game.mainSocket.emit('queueBrood', {
                queenId: this.currentQueenId,
                type: type
            });
        },
        removeBrood: function(index) {
            game.mainSocket.emit('removeBrood', {
                queenId: this.currentQueenId,
                index: index
            });
        },
        setTeamInfo: function(teamInfo) {
            this.teamInfo = teamInfo;
        },
        getFoodTypeStyle: function(type) {
            let offsetx = 0;
            let offsety = 0;
            switch(type) {
                case 'honeydew':
                    offsetx = 0;
                    offsety = 0;
                    break;
                case 'plant':
                    offsetx = 1;
                    offsety = 0;
                    break;
                case 'meat':
                    offsetx = 2;
                    offsety = 0;
                    break;
                case 'blue':
                    offsetx = 3;
                    offsety = 0;
                    break;
                case 'red':
                    offsetx = 0;
                    offsety = 1;
                    break;
            }
            return {
                display: 'inline-block',
                position: 'relative',
                top: '6px',
                margin: '0px',
                marginLeft: 'auto',
                marginRight: 'auto',
                width: 32 + 'px',
                height: 32 + 'px',
                transform: 'scale(1.2)',
                background: 'url(\'assets/resources.png\') ' + (offsetx * -32) + 'px ' + (offsety * -32) + 'px'
            };
        }
    },
    template: `
    <div>
        <div class="text-left" v-if="teamInfo && teamInfo.isLeader">
            <button type="button" v-for="queenId in teamInfo.queens" class="app-btn app-btn-secondary" v-on:click="openQueen(queenId)" style="width:220px;">
                <img alt="Queen Menu" style="width:25px; height:25px;" src="assets/queen_icon.png"> Queen <span v-if="queenData[queenId] && queenData[queenId].broodQueue">({{queenData[queenId].broodQueue.length}})</span>
            </button>
        </div>
        <div class="game-modal" v-if="shouldShowModal">
            <div class="game-modal-content game-modal-content-sm" v-if="currentQueenId && queenData[currentQueenId]">
                <button type="button" v-on:click="showModal(false)" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2><img alt="Queen Menu" style="width:40px; height:40px;" src="assets/queen_icon.png"> Queen Menu</h2>
                <div style="margin-left:auto; margin-right:auto;">
                    <button type="button" v-for="(brood, key) in queenData[currentQueenId].broodTypes" class="app-btn app-btn-secondary" v-on:click="queueBrood(key)" style="width:170px; margin-left:5px;">
                        <i class="fa fa-plus"></i> {{brood.name}}<br>
                        <div v-for="(amount, type) in brood.cost" style="display:inline-block; margin-right:6px;">
                            <div v-for="n in amount" v-bind:style="getFoodTypeStyle(type)"></div>
                        </div>
                    </button>
                </div>
                <br>
                <h2>Brood Queue ({{queenData[currentQueenId].broodQueue.length}}/10)</h2>
                <div class="scrollable" style="width:100%; height:400px; clear:both;">
                    <h3 v-if="queenData[currentQueenId].broodQueue.length <= 0" class="text-center">
                        <br>
                        Select brood above and give the queen the required food to birth new ants. 
                    </h3>
                    <div v-for="(brood, index) in queenData[currentQueenId].broodQueue" class="app-card">
                        {{index+1}}. {{brood.name}}<br>
                        <span v-if="Object.keys(brood.cost).length <= 0">Gestating...</span>
                        <div v-for="(amount, type) in brood.cost" style="display:inline-block; margin-right:6px;">
                            <div v-for="n in amount" v-bind:style="getFoodTypeStyle(type)"></div>
                        </div>
                        <div class="pull-right">
                            <button type="button" class="app-btn app-btn-sm app-btn-danger" v-on:click="removeBrood(index)">
                                <i class="fa fa-close clickable"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `
})